<template>
  <div>
    <product-slider
      :alts="alts"
      :number-of-slides-desktop="numberOfSlidesDesktop"
      :enable-pagination="enablePagination"
    >
      <slide
        v-for="(recommendation, $index) in recommendations"
        :key="$index"
        :custom-attributes="{ 'data-evg-clickthrough': '' }"
      >
        <div
          v-tag:productimpression.dom="{ label: 'product impressions' }"
          v-tag:productclick.dom="{ label: 'Product Click' }"
          data-tag-wrapper
        >
          <div
            data-tag-product-identifier
            data-tag-product-currency="USD"
            :data-tag-product-position="$index + 1"
            :data-tag-product-name="recommendation.productName"
            :data-tag-product-id="recommendation.productCode"
            data-tag-product-brand="Cev"
            data-tag-product-list="Curated Products"
            :data-tag-product-dimension35="recommendation.tagging.dimension35"
            :data-tag-product-dimension38="recommendation.tagging.dimension38"
            :data-tag-product-dimension39="recommendation.tagging.dimension39"
            data-tag-product-dimension49="not present"
            :data-tag-product-dimension59="recommendation.totalReviews"
            :data-tag-product-metric52="recommendation.comingSoon"
          >
            <a
              class="product-card"
              :href="recommendation.url"
            >
              <div class="image">
                <img
                  v-if="hasImage(recommendation)"
                  v-srcset="recommendation.image.srcset"
                  :alt="recommendation.image.alt"
                  class="image__item"
                  :src="recommendation.image.src"
                >
              </div>
              <div class="product-heading">
                <h3>{{ recommendation.productName }}</h3>
              </div>
              <p>{{ recommendation.productMainBenefit }}</p>

              <lazyloading-wrapper
                v-if="hasBazaarvoiceInlineRating"
                class="rating"
              >
                <div
                  data-bv-show="inline_rating"
                  data-bv-seo="false"
                  :data-bv-product-id="recommendation.productCode"
                />
              </lazyloading-wrapper>
            </a>
          </div>
        </div>
      </slide>
    </product-slider>
  </div>
</template>
<script>
  import ProductSlider from '@Feature/ProductSlider/code/Scripts/components/ProductSlider/ProductSlider.vue';
  import Slide from '@Feature/Carousel/code/Scripts/components/slide/slide.vue';
  import LazyloadingWrapper from '@Feature/RatingsAndReviews/code/Scripts/components/LazyloadingWrapper/LazyloadingWrapper.vue';
  import { srcset } from '@Foundation/directives/srcset/srcset';
  import { tag } from '@Foundation/analyticsHandler/directives/tag';

  export default {
    name: 'SfmcProducts',
    components: {
      ProductSlider,
      Slide,
      LazyloadingWrapper
    },
    directives: {
      srcset,
      tag
    },
    props: {
      alts: {
        type: Object,
        required: true
      },
      numberOfSlidesDesktop: {
        type: Number,
        required: false,
        default: null
      },
      enablePagination: {
        type: Boolean,
        required: false
      },
      hasBazaarvoiceInlineRating: {
        type: Boolean,
        required: false,
        default: false
      },
      recommendations: {
        type: Array,
        required: true
      }
    },
    methods: {
      hasImage(recommendation) {
        return !!(
          recommendation &&
          recommendation.image &&
          recommendation.image.src
        );
      }
    }
  };
</script>
